import { render, staticRenderFns } from "./LabelContractsCostsEditPanelDialog.vue?vue&type=template&id=17643b20"
import script from "./LabelContractsCostsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./LabelContractsCostsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports